/**
 * カテゴリ同意状態 → GTM同意モード v2 同意タイプへの変換と発火
 *
 * GTM の consent コマンドは gtag() 関数（= dataLayer.push(arguments)）経由で
 * 発火する必要がある。素の dataLayer.push([...]) の配列形式では認識されない。
 * <head> の inline default script で定義した window.gtag を再利用する。
 *
 * 同一同意タイプは1カテゴリにしか割り当てられない（DBバリデーション）ため、
 * 単純な代入で OK（OR/AND 結合の判断は不要）。
 *
 * @param {Object<string, boolean>} categories - カテゴリキー → 同意状態
 * @param {Array<{key: string, required: boolean, gtmSignals: string[]}>} configCategories - CMP設定のカテゴリ定義
 */
export function pushGtmConsentUpdate(categories, configCategories) {
  if (!Array.isArray(configCategories)) return;
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  const signals = {};
  configCategories.forEach((cat) => {
    if (!Array.isArray(cat.gtmSignals)) return;
    const granted = cat.required || Boolean(categories && categories[cat.key]);
    cat.gtmSignals.forEach((sig) => {
      signals[sig] = granted ? 'granted' : 'denied';
    });
  });

  if (Object.keys(signals).length === 0) return;
  window.gtag('consent', 'update', signals);
}

/**
 * GTM同意モードが有効な場合のみ consent update を発火する
 *
 * 有効判定（gtmConsentMode.enabled）と発火をセットで提供し、
 * 呼び出し側でのガード条件の重複を防ぐ。
 *
 * @param {Object} config - バリデーション済みCMP設定
 * @param {Object<string, boolean>} categories - カテゴリキー → 同意状態
 */
export function pushGtmConsentUpdateIfEnabled(config, categories) {
  if (!config.gtmConsentMode || !config.gtmConsentMode.enabled) return;
  pushGtmConsentUpdate(categories, config.categories);
}

/**
 * 全カテゴリ granted の同意状態オブジェクトを生成する
 *
 * @param {Array<{key: string}>} configCategories - CMP設定のカテゴリ定義
 * @returns {Object<string, boolean>}
 */
export function buildAllGrantedCategories(configCategories) {
  const categories = {};
  (configCategories || []).forEach((cat) => {
    categories[cat.key] = true;
  });
  return categories;
}
